import React from "react";
import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
  TabContent,
  TabPane,
  Row,
  Col
} from "reactstrap";

function Tab1({ activeTab, updateActiveTab }) {
  const handleExportClick = () => {
    updateActiveTab("2");
  };

  const handleImportClick = () => {
    updateActiveTab("3");
  };

  return (
    <div>
      <TabContent activeTab={activeTab} className="mt-4">
        <TabPane tabId="1" id="select-option">
          <h4 className="card-title mb-4">Select Option</h4>
          <Row>
            <Col md="6">
              <Card className="mb-4">
                <CardBody>
                  <CardTitle tag="h5">Export</CardTitle>
                  <CardText>
                    Export all client data to a CSV file. This will allow you to save the current data and use it externally.
                  </CardText>
                  <Button color="primary" onClick={handleExportClick}>
                    Export
                  </Button>
                </CardBody>
              </Card>
            </Col>
            <Col md="6">
              <Card className="mb-4">
                <CardBody>
                  <CardTitle tag="h5">Import</CardTitle>
                  <CardText>
                    Import data from a CSV file. This will replace the current data with the new data from the file.
                  </CardText>
                  <Button color="secondary" onClick={handleImportClick}>
                    Import
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </TabPane>
      </TabContent>
    </div>
  );
}

export default Tab1;
